"use client";

import { useTheme } from "@/context/theme-context";
import Icon from "./icon";

const THEMES = ["", "dark", "light"];

type ThemeSwitcherProps = {
  className?: string;
};

const ThemeSwitcher = (props: ThemeSwitcherProps) => {
  const { theme, switchTheme } = useTheme();

  const currentThemeIndex = THEMES.indexOf(theme || "");
  const nextThemeIndex =
    currentThemeIndex === THEMES.length - 1 ? 0 : currentThemeIndex + 1;

  return (
    <button
      aria-label="Tema"
      onClick={() => switchTheme(THEMES[nextThemeIndex])}
      className={props.className}
    >
      {theme === undefined && <Icon.Computer />}
      {theme === "light" && <Icon.Sun />}
      {theme === "dark" && <Icon.Moon />}
    </button>
  );
};

export default ThemeSwitcher;
